/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Fact_Commands_LInputs */

const en_wc_fact_commands_l = /** @type {(inputs: Wc_Fact_Commands_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Commands behind the ribbon, CLI and MCP.`)
};

/**
* | output |
* | --- |
* | "Commands behind the ribbon, CLI and MCP." |
*
* @param {Wc_Fact_Commands_LInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_fact_commands_l = /** @type {((inputs?: Wc_Fact_Commands_LInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Fact_Commands_LInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_fact_commands_l(inputs)
});
export { wc_fact_commands_l as "wc.fact.commands_l" }